import { Injectable } from '@angular/core';
import { HttpHeaders } from '@angular/common/http';
//import { Contacts } from '../../model/contacts';


@Injectable({
  providedIn: 'root'
})
export class StorageService {

  //private contactSelected: Contacts;

  constructor(
    
  ) {

   }

  public storeToLocalStorage(key: string, value: any) {
    localStorage.setItem(key, value);
    // await this.platform.ready()
    // return await this.nStorage.setItem(key,value)
  }

  public getFromLocalStorage(key: string){
    // await this.platform.ready()
    // return await this.nStorage.getItem(key).then(
    //   (data:any) => {
    //      return data
    //   }
    // )
    return localStorage.getItem(key);
  }

  public clearLocalStorage() {
    localStorage.clear();
  }

  public getAccessToken(): string {
    return localStorage.getItem("access_token");
  }

  public getUser() {
    var obj;

    obj = JSON.parse(localStorage.getItem("user"));

    return obj;
  }

  public getPermissions() {
    var obj;

    obj = JSON.parse(localStorage.getItem("user"));

    if (obj != null) {
      return obj.permissions;
    }
    return obj;
  }

  public getHeaders() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.getAccessToken(),
      }),
    };

    return httpOptions;
  }

  public head(){
    return new HttpHeaders({
      'Accept': 'application/excel',
      'Authorization': 'Bearer ' + this.getAccessToken(),
    })
  }

  public token(){
    return this.getAccessToken()
  }

  public getHeadersBlob() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json',
        'Authorization': 'Bearer ' + this.getAccessToken(),
      }),
      responseType: 'arraybuffer',
    };

    return httpOptions;
  }

  public getHeadersNoAuth() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Accept': 'application/json'
      }),
    };

    return httpOptions;
  }

  public getHead() {
    return new HttpHeaders({
      'Accept': 'application/json',
      'Authorization': 'Bearer ' + this.getAccessToken(),
    })
  }


//   public setContactSelected(obj: any) {
//     sessionStorage.setItem("contactSelected", JSON.stringify(obj));
//   }

//   public getContactSelected() {
//     return JSON.parse(sessionStorage.getItem("contactSelected"));
//   }


}
